import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ConfirmDialogData} from '../confirm-dialog/confirm-dialog.component';
import {FormBuilder, FormControl} from '@angular/forms';

export interface ConfirmResult {
  accepted: boolean;
  reason: string;
}

@Component({
  selector: 'app-confirm-dialog-with-reason',
  templateUrl: './confirm-dialog-with-reason.component.html',
  styleUrls: ['./confirm-dialog-with-reason.component.scss']
})
export class ConfirmDialogWithReasonComponent {
  text = '';

  reasonControl: FormControl;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogWithReasonComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    private fb: FormBuilder,
  ) {
    this.text = data.text;
    this.reasonControl = fb.control('');
  }

  confirm(): void {
    this.dialogRef.close({
      accepted: true,
      reason: this.reasonControl.value
    });
  }

  decline(): void {
    this.dialogRef.close({
      accepted: false,
      reason: ''
    });
  }
}
